import React from 'react';
import AccountsStore from '../../stores/AccountsStore';
import envConfig from '../../../static/config';
import HomepageAdverts from './HomepageAdverts';
import HomepageBL from './HomepageBL';
import FavouritesStore from '../../stores/AccountsStore/FavouritesStore';
import UserManagementStore from '../../stores/UserManagementStore';
import { SecureMessage } from './SecureMessage';
import { MTrackTile } from './MTrackTile';
import ChatTile from './ChatTile';

import {
  shouldShowSecureMessages,
  isMTrackTileEnabled,
} from './HomepageTilesUtils';

export const homepageAdvertsList = ({ advertClick, messageCount, content }) => {
  let ads = [];
  let index = 0;
  if (isMTrackTileEnabled()) {
    ads.push(
      <div
        key="HomepageAdvertsList_isMTrackTileEnabled"
        className="mtrack-tile__dashboard-container-list l-tile"
      >
        <MTrackTile />
      </div>
    );
  }
  if (UserManagementStore.isBusinessUser()) {
    ads.push(
      <ChatTile
        key="HomepageAdvertsList_ChatTile_isBusinessUser"
        content={content}
      />
    );
  }
  if (AccountsStore.getPotsFlag()) {
    index++;
    ads.push(
      <HomepageAdverts
        advert={HomepageBL.getAdverts('savingspot')}
        advertClick={advertClick}
        index={index}
        key={`HomepageAdvertsList_HomepageAdverts_${index}`}
      />
    );
  }
  if (
    !FavouritesStore.isLargeCustomer() &&
    ((AccountsStore.getSweepsFlag() && AccountsStore.getSweepsOutFlag()) ||
      AccountsStore.getAlertsFlag())
  ) {
    index++;
    ads.push(
      <HomepageAdverts
        advert={HomepageBL.getAdverts('alerts')}
        advertClick={advertClick}
        index={index}
        key={`HomepageAdvertsList_HomepageAdverts_${index}`}
      />
    );
  }
  if (shouldShowSecureMessages()) {
    ads.push(
      <SecureMessage
        key="HomepageAdvertsList_SecureMessage"
        count={messageCount}
        content={content}
      />
    );
  }
  if (AccountsStore.getSpendingsFlag()) {
    index++;
    ads.push(
      <HomepageAdverts
        advert={HomepageBL.getAdverts('spending')}
        advertClick={advertClick}
        index={index}
        key={`HomepageAdvertsList_HomepageAdverts_${index}`}
      />
    );
  }
  if (
    UserManagementStore.isSMEUser() &&
    envConfig.isManageAccountPoolsEnabled &&
    AccountsStore.getTotalNumberOfAccounts() > 1
  ) {
    index++;
    ads.push(
      <HomepageAdverts
        advert={HomepageBL.getAdverts('manageaccountpools')}
        advertClick={advertClick}
        index={index}
        key={`HomepageAdvertsList_HomepageAdverts_${index}`}
      />
    );
  }
  if (UserManagementStore.isCA() && envConfig.isMarketplaceEnabled) {
    index++;
    ads.push(
      <HomepageAdverts
        advert={HomepageBL.getAdverts('marketplace')}
        advertClick={advertClick}
        index={index}
        key={`HomepageAdvertsList_HomepageAdverts_${index}`}
      />
    );
  }
  if (
    !UserManagementStore.isBusinessUser() &&
    !UserManagementStore.isNominatedUser() &&
    envConfig.isVulnerableCustomersEnabled
  ) {
    index++;
    ads.push(
      <HomepageAdverts
        advert={HomepageBL.getAdverts('vulnerable-customers')}
        advertClick={advertClick}
        index={index}
        key={`HomepageAdvertsList_HomepageAdverts_${index}`}
      />
    );
  }
  /**
   * @note Sadly React v15 doesn't allow us to just render an array,
   * so this component has to be called like a function instead.
   */
  return ads;
};
